import * as RadixTooltip from "@radix-ui/react-tooltip";

interface TooltipProps {
  children: React.ReactNode;
  label: string;
  labelClassName?: string;
}

export default function Tooltip({
  children,
  label,
  labelClassName = "shadow-lg px-2 py-1 rounded max-w-[300px] bg-page",
}: TooltipProps) {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content className={labelClassName} sideOffset={5}>
            {label}
            <RadixTooltip.Arrow className="fill-current text-on-primary" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
